const network = {
  namespaced: true,
  state: {
    chain: {},
  },
  mutations: {
    setChain(state, payload) {
      state.chain = payload;
    },
  },
  getters: {
    chainList() {
      return {
        ethereum: {
          id: 1,
          name: "Ethereum",
          wrappedToken: "ETH",
          explorerUrl: "https://etherscan.io",
          routeAddress: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
          routeAddressV3: "0xE592427A0AEce92De3Edee1F18E0157C05861564",
          factoryAddress: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
          factoryAddressV3: "0x1F98431c8aD98523631AE4a59f267346ea31F984",
          quoterContractAddress: "0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6",
          wrappedAddress: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
          feeTiers: [500, 3000, 10000],
          rpcUrl: "https://ethereum-rpc.publicnode.com",
          networkBitquery: "eth",
          dexToolsPathName: "ether",
          logo: require("@/assets/ethereum.webp"),
        },
        base: {
          id: 8453,
          name: "Base",
          wrappedToken: "ETH",
          explorerUrl: "https://basescan.org",
          routeAddress: "0x4752ba5DBc23f44D87826276BF6Fd6b1C372aD24",
          routeAddressV3: "0x2626664c2603336E57B271c5C0b26F421741e481",
          factoryAddress: "0x8909Dc15e40173Ff4699343b6eB8132c65e18eC6",
          factoryAddressV3: "0x33128a8fC17869897dcE68Ed026d694621f6FDfD",
          quoterContractAddress: "0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6",
          wrappedAddress: "0x4200000000000000000000000000000000000006",
          feeTiers: [500, 3000, 10000],
          rpcUrl: "https://base-rpc.publicnode.com",
          networkBitquery: "base",
          dexToolsPathName: "base",
          logo: require("@/assets/base.webp"),
        },
        bsc: {
          id: 56,
          name: "BSC",
          wrappedToken: "BNB",
          explorerUrl: "https://bscscan.com",
          fourMeme: {
            poolAddress: "0xF251F83e40a78868FcfA3FA4599Dad6494E46034",
            tradeAddress: "0x5c952063c7fc8610FFDB798152D69F0B9550762b",
          },
          routeAddress: "0x10ed43c718714eb63d5aa57b78b54704e256024e",
          routeAddressV3: "0x1b81D678ffb9C0263b24A97847620C99d213eB14",
          factoryAddress: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
          factoryAddressV3: "0x0BFbCF9fa4f9C56B0F40a671Ad40E0805A091865",
          quoterContractAddress: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
          wrappedAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
          feeTiers: [2500, 100, 500, 10000],
          rpcUrl:
            "https://dimensional-thrilling-shape.bsc.quiknode.pro/6e4ec3879f4b45be3ace54ac8c022860aabc90bb",
          networkBitquery: "bsc",
          dexToolsPathName: "bsc",
          logo: require("@/assets/bsc.svg"),
        },
        solana: {
          id: 900,
          name: "Solana",
          wrappedToken: "SOL",
          explorerUrl: "https://solscan.io",
          rpcUrl:
            "https://mainnet.helius-rpc.com/?api-key=9af21197-faa1-45de-bd64-f08b576e491b",
          logo: require("@/assets/solana.webp"),
        },
      };
    },
    chainId(state) {
      return state.chain.id;
    },
    chainName(state) {
      return state.chain.name;
    },
    wrappedToken(state) {
      return state.chain.wrappedToken;
    },
    networkBitquery(state) {
      return state.chain.networkBitquery;
    },
    explorerUrl(state) {
      return state.chain.explorerUrl;
    },
    shortAddress: (state, getters) => (address) => {
      switch (getters.chainName) {
        case "Solana":
        case "Ethereum":
        case "Base":
        case "BSC":
        default:
          return `${address.slice(0, 7)}...${address.slice(-5)}`;
      }
    },
    explorerUrlAddress: (state, getters) => (address) => {
      switch (getters.chainName) {
        case "Solana":
          return `${getters.explorerUrl}/account/${address}`;
        case "Ethereum":
        case "Base":
        case "BSC":
        default:
          return `${getters.explorerUrl}/address/${address}`;
      }
    },
    explorerUrlToken: (state, getters) => (address) => {
      return `${getters.explorerUrl}/token/${address}`;
    },
    explorerUrlTxn: (state, getters) => (txn) => {
      return `${getters.explorerUrl}/tx/${txn}`;
    },
    getLocalStorage(state, getters) {
      const localStorageData = localStorage.getItem(
        getters.chainName.toLowerCase()
      );
      if (localStorageData) {
        return JSON.parse(localStorageData);
      }
      return {};
    },
  },
  actions: {
    setLocalStorage({ getters }, payload) {
      return localStorage.setItem(
        getters.chainName.toLowerCase(),
        JSON.stringify(payload)
      );
    },
    updateLocalStorage({ getters, dispatch }, payload) {
      return dispatch(
        "setLocalStorage",
        Object.assign({}, getters.getLocalStorage, payload)
      );
    },
  },
};

export default network;
